export const isExpired = (expiration_date) => {
    const expirationDate = new Date(expiration_date);
    const currentDate = new Date();
    const expired = currentDate > expirationDate;
    const formattedDate = `${(expirationDate.getMonth() + 1).toString().padStart(2, "0")}/${expirationDate.getFullYear()}`;

    return { expired, formattedDate };
};



export const formatDate = (dateString) => {

    if (dateString) {
        const date = new Date(dateString)
        const day = date.getDate().toString().padStart(2, '0')
        const month = (date.getMonth() + 1).toString().padStart(2, '0')
        const year = date.getFullYear()

        return `${day}/${month}/${year}`
    } else {
        return ''
    }

}

const STATUS = {
    IS_EXPIRED: "IS_EXPIRED",
    STILL_ACTIVE: "STILL_ACTIVE",
    IN_EXPIRATION: "IN_EXPIRATION",
}

export const isExpiringSoon = (dateString) => {
    const now = new Date();
    const expiredAt = new Date(dateString);

    const diffTime = expiredAt - now;
    const diffDays = diffTime / (1000 * 60 * 60 * 24);

    if (diffDays <= 0) {
        return STATUS.IS_EXPIRED;
    } else if (diffDays <= 7) {
        return STATUS.IN_EXPIRATION;
    } else {
        return STATUS.STILL_ACTIVE;
    }
}